// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"1f3a2121","4303":"819a6682","5066":"57d5ace2","6558":"d42c0166","7945":"aec78970"}[chunkId] + ".css";
};